import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __experimentalToolsPanelContext as ToolsPanelContext } from '@wordpress/components';
import { useContext } from '@wordpress/element';
export default function BlockSupportSlotContainer(_ref) {
  let {
    Slot,
    ...props
  } = _ref;
  const toolsPanelContext = useContext(ToolsPanelContext);
  return createElement(Slot, _extends({}, props, {
    fillProps: toolsPanelContext,
    bubblesVirtually: true
  }));
}
//# sourceMappingURL=block-support-slot-container.js.map